import React, { useEffect, useState } from 'react';
import '../../css/modal.css';
import { Query } from '../../types/Query';
import { fetchQueryById } from '../../api/Query';
import { formatDate } from '../../utils/date';

interface QueryInfoModalProps {
  queryId: number;
  onClose: () => void;
}

const QueryInfoModal: React.FC<QueryInfoModalProps> = ({ queryId, onClose }) => {
  const [query, setQuery] = useState<Query | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadQuery = async () => {
      try {
        setLoading(true);
        const data = await fetchQueryById(queryId);
        setQuery(data);
      } catch (error) {
        console.error('Failed to fetch query:', error);
        setQuery(null);
      } finally {
        setLoading(false);
      }
    };

    if (queryId) {
      loadQuery();
    }
  }, [queryId]);

  if (loading) {
    return (
      <div className="modal-backdrop">
        <div className="modal">
          <div className="modal-header">
            <h2>Query Info</h2>
            <button className="close-btn" onClick={onClose}>×</button>
          </div>
          <div className="modal-body">
            <p>Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!query) {
    return (
      <div className="modal-backdrop">
        <div className="modal">
          <div className="modal-header">
            <h2>Query Info</h2>
            <button className="close-btn" onClick={onClose}>×</button>
          </div>
          <div className="modal-body">
            <p>Query not found</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-backdrop">
      <div className="modal">
        <div className="modal-header">
          <h2>Query Info</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <p><strong>Query ID:</strong> #{query.id}</p>
          <p><strong>Customer:</strong> {query.customer?.name || '—'}</p>
          <p><strong>Location:</strong> {query.location || '—'}</p>
          <p><strong>Type:</strong> {query.type || '—'}</p>
          <p><strong>Source:</strong> {query.source || '—'}</p>
          <p><strong>Description:</strong> {query.description || '—'}</p>
          <p><strong>Status:</strong> {query.status || '—'}</p>
          <p><strong>Query Date:</strong> {query.queryDate ? formatDate(query.queryDate) : '—'}</p>
          <p><strong>Pax:</strong> {query.pax || '—'}</p>
          <p><strong>Engagement Level:</strong> {query.engagementLevel || '—'}</p>
          {query.assignedTo && (
            <p><strong>Assigned To:</strong> {query.assignedTo.name}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default QueryInfoModal;

